<template>
  <div>
    <a-spin :spinning="loading">
      <div v-if="lessonPlan">
        <div class="row mb-4">
          <div class="col-12 col-md-8">
            <table class="table table-borderless table-sm mb-0">
              <tbody>
                <tr>
                  <th style="width: 150px;">Lesson Plan</th>
                  <td class="font-weight-bold text-primary">{{ lessonPlan.name }}</td>
                </tr>
                <tr>
                  <th>Class</th>
                  <td>{{ lessonPlan.school_class.name }}</td>
                </tr>
                <tr>
                  <th>Subject</th>
                  <td>{{ lessonPlan.subject.name }}</td>
                </tr>
                <tr>
                  <th>Session</th>
                  <td>{{ lessonPlan.session.name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <a-tabs v-if="structuredTerms.length > 0" :default-active-key="String(structuredTerms[0].id)">
          <a-tab-pane
            v-for="term in structuredTerms"
            :key="String(term.id)"
            :tab="term.name"
          >
            <a-collapse v-if="term.topics.length > 0" :activeKey="term.topics.length > 0 ? String(term.topics[0].id) : null">
              <a-collapse-panel
                v-for="topic in term.topics"
                :key="String(topic.id)"
              >
                <template #header>
                  <div class="d-flex justify-content-between align-items-center">
                    <span>{{ topic.topic_name }}</span>
                    <div>
                      <a-tag :color="getStatusColor(getTopicStatus(topic))" class="mr-3">
                        {{ getTopicStatus(topic) }}
                      </a-tag>
                      <a href="javascript:;" class="btn btn-sm btn-info btn-with-addon mr-2"
                          @click.stop="openViewLogsModal(topic)">
                          <span class="btn-addon">
                            <i class="btn-addon-icon fe fe-eye" />
                            </span>
                            View Details
                            </a>
                       <a href="javascript:;" class="btn btn-sm btn-primary btn-with-addon mr-2"
                            @click.stop="openUpdateModal(topic, 'topic')">
                            <span class="btn-addon">
                            <i class="fe fe-trending-up btn-addon-icon" />
                            </span>
                            Update Progress
                            </a>
                    </div>
                  </div>
                </template>

                <a-list item-layout="horizontal" :data-source="topic.sub_topics">
                  <a-list-item slot="renderItem" slot-scope="subTopic">
                    <div class="d-flex justify-content-between align-items-center w-100">
                      <span>{{ subTopic.sub_topic_name}}</span>
                       <div>
                        <a-tag v-if="getLatestStatus(subTopic.progress_logs)"
                          :color="getStatusColor(getLatestStatus(subTopic.progress_logs))"
                          class="mr-3">
                          {{ getLatestStatus(subTopic.progress_logs) }}
                        </a-tag>
                         <a href="javascript:;" class="btn btn-sm btn-info btn-with-addon mr-2"
                          @click.stop="openViewLogsModal(subTopic)">
                          <span class="btn-addon">
                            <i class="btn-addon-icon fe fe-eye" />
                            </span>
                            View Details
                            </a>
                            <a href="javascript:;" class="btn btn-sm btn-primary btn-with-addon mr-2"
                            @click.stop="openUpdateModal(subTopic, 'sub-topic')">
                            <span class="btn-addon">
                            <i class="fe fe-trending-up btn-addon-icon" />
                            </span>
                            Update Progress
                            </a>
                        <!-- <a-button type="primary" size="small" @click.stop="openUpdateModal(subTopic, 'sub-topic')">
                          Update Progress
                        </a-button> -->
                      </div>
                    </div>
                  </a-list-item>
                </a-list>
                 <div v-if="!topic.sub_topics || topic.sub_topics.length === 0" class="pl-4">
                    No sub-topics found.
                </div>
              </a-collapse-panel>
            </a-collapse>
             <div v-else>
               No topics found for this term.
             </div>
          </a-tab-pane>
        </a-tabs>
        <div v-else>
           <a-alert message="No terms or topics found for this lesson plan." type="info" show-icon />
        </div>
      </div>
      <div v-else-if="!loading">
        <a-alert
          message="Error"
          description="Could not load the lesson plan details. Please go back and try again."
          type="error"
          show-icon
        />
      </div>
    </a-spin>
    <update-progress-modal
      :visible="updateModalVisible"
      :item="selectedItem"
      :lessonPlan="lessonPlan"
      @close="updateModalVisible = false"
      @updated="fetchLessonPlanDetails"
    />
    <view-logs-modal
    :visible="viewLogsVisible"
    :item="selectedItem"
    @close="viewLogsVisible = false"
     @edit-log="openEditModal"
    />
    <edit-progress-modal
      :visible="editModalVisible"
      :progressLog="selectedLogForEdit"
      :lessonPlan="lessonPlan"
      @close="editModalVisible = false"
      @updated="fetchLessonPlanDetails"
    />
    </div>
</template>

<script>
import UpdateProgressModal from '@/components/teacherprogress/Form/updateProgress'
import ViewLogsModal from '@/components/teacherprogress/Form/viewTeacherLog'
import EditProgressModal from '@/components/teacherprogress/Form/editUpdateProgress'
export default {
  components: { UpdateProgressModal, ViewLogsModal, EditProgressModal },
  name: 'DisplayLessonPlan',
  computed: {
    planId() {
      return this.$route.params.plan_id
    },

    // NEW: This computed property transforms the API data into the structure we need
    structuredTerms() {
      if (!this.lessonPlan || !this.lessonPlan.topics) {
        return []
      }

      // Group topics by their academic_term_id
      const groups = this.lessonPlan.topics.reduce((acc, topic) => {
        const termId = topic.academic_term_id
        const termObj = this.terms.find(t => t.id === termId)
        if (!acc[termId]) {
          acc[termId] = { id: termId, name: termObj ? termObj.name : `Term ${termId}`, topics: [] }
        }
        acc[termId].topics.push(topic)
        return acc
      }, {})

      // Convert the grouped object back into an array for v-for
      return Object.values(groups)
    },
  },
  data() {
    return {
      loading: false,
      lessonPlan: null,
      terms: [],
      updateModalVisible: false,
      editModalVisible: false,
      viewLogsVisible: false,
      selectedItem: null,
      selectedLogForEdit: null,

    }
  },
  mounted() {
    this.loading = true
    this.fetchTerms().then(() => {
      this.fetchLessonPlanDetails()
    })
  },
  methods: {
    fetchTerms() {
      return this.$http.get('/api/lesson-plan/academic-terms')
        .then(({ data }) => {
          this.terms = data.data
        })
        .catch(error => {
          console.error('Failed to fetch academic terms', error)
        })
    },
    getLatestStatus(logs) {
      if (!logs || logs.length === 0) return null
      return logs[logs.length - 1].status
    },
    getTopicStatus(topic) {
      if (topic.sub_topics && topic.sub_topics.length > 0) {
        const statuses = topic.sub_topics.map(st => this.getLatestStatus(st.progress_logs) || 'Not Started')
        const completedCount = statuses.filter(s => s === 'Completed').length
        const inProgressCount = statuses.filter(s => s === 'In Progress').length
        const startedCount = statuses.filter(s => s === 'Started').length

        if (completedCount === statuses.length && statuses.length > 0) return 'Completed'
        if (completedCount > 0 || inProgressCount > 0) return 'In Progress'
        if (startedCount > 0) return 'Started'
        return 'Not Started'
      }
      return this.getLatestStatus(topic.progress_logs) || 'Not Started'
    },
    getStatusColor(status) {
      switch (status) {
        case 'Completed':
          return 'green'
        case 'In Progress':
          return 'blue'
        case 'Started':
          return 'orange'
        case 'Not Started':
        default:
          return 'default'
      }
    },
    openViewLogsModal(item) {
      this.selectedItem = { id: item.id, type: item.topic_name ? 'topic' : 'sub-topic' }
      this.viewLogsVisible = true
    },
    openEditModal(log) {
      this.viewLogsVisible = false
      this.selectedLogForEdit = log
      this.editModalVisible = true
    },
    fetchLessonPlanDetails() {
      if (!this.planId) return
      this.loading = true
      this.$http
        .get(`/api/lesson-plan/teacher/lesson-plans/${this.planId}`)
        .then(({ data }) => {
          this.lessonPlan = data.data
          this.loading = false
        })
        .catch(error => {
          console.error('Error fetching lesson plan details:', error)
          this.loading = false
          this.$notification.error({
            message: 'Failed to Load Data',
            description: 'There was an issue retrieving the lesson plan details.',
          })
        })
    },
    openUpdateModal(item, type) {
      this.selectedItem = {
        id: item.id,
        type: type, // 'topic' or 'sub-topic'
      }
      this.updateModalVisible = true
      this.$message.info(
        `Opening update modal for ${type}: ${
          type === 'topic' ? item.topic_name : item.sub_topic_name
        }`
      )
    },

  },
}
</script>

<style scoped>
/* Optional: Adds a bit of spacing for a cleaner look */
.ant-list-item {
  padding-left: 24px;
}
</style>
